import type { ResourceType } from "@gettactic/api";
import type { MapModalParams } from "../components/modal/types";

/** The reservation panel tab a resource of this type is booked from. */
export const getMapModalTab = (
  resourceType: ResourceType
): NonNullable<MapModalParams["defaultTab"]> => {
  if (resourceType === "meeting_room") return "rooms";
  if (resourceType === "parking_lot" || resourceType === "parking_space") {
    return "other";
  }
  return "desks";
};
